"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateHighlightSourceDtoPreferredSourceEnum = void 0;
exports.instanceOfUpdateHighlightSourceDto = instanceOfUpdateHighlightSourceDto;
exports.UpdateHighlightSourceDtoFromJSON = UpdateHighlightSourceDtoFromJSON;
exports.UpdateHighlightSourceDtoFromJSONTyped = UpdateHighlightSourceDtoFromJSONTyped;
exports.UpdateHighlightSourceDtoToJSON = UpdateHighlightSourceDtoToJSON;
exports.UpdateHighlightSourceDtoToJSONTyped = UpdateHighlightSourceDtoToJSONTyped;
/**
 * @export
 */
exports.UpdateHighlightSourceDtoPreferredSourceEnum = {
    Ott: 'ott',
    Youtube: 'youtube'
};
/**
 * Check if a given object implements the UpdateHighlightSourceDto interface.
 */
function instanceOfUpdateHighlightSourceDto(value) {
    if (!('youtube_fallback_enabled' in value) || value['youtube_fallback_enabled'] === undefined)
        return false;
    if (!('preferred_source' in value) || value['preferred_source'] === undefined)
        return false;
    return true;
}
function UpdateHighlightSourceDtoFromJSON(json) {
    return UpdateHighlightSourceDtoFromJSONTyped(json, false);
}
function UpdateHighlightSourceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'youtube_fallback_enabled': json['youtube_fallback_enabled'],
        'preferred_source': json['preferred_source'],
    };
}
function UpdateHighlightSourceDtoToJSON(json) {
    return UpdateHighlightSourceDtoToJSONTyped(json, false);
}
function UpdateHighlightSourceDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'youtube_fallback_enabled': value['youtube_fallback_enabled'],
        'preferred_source': value['preferred_source'],
    };
}
